import React, { useContext, useEffect, useState } from "react";
import RequestedCoursesComponent from "./RequestedCoursesComponent";
import {Button, Tab, Tabs } from "@mui/material";
import AssignmentForOtherDept from "./AssignmentForOtherDept";
import { Box } from "@mui/system";
import OwnCourseAssignmentComponent from './OwnCourseAssignmentComponent'
import { Route, Routes, useNavigate } from "react-router-dom";
import RequireAuth from "../RequireAuth"
import GetCookie from "../../hooks/getCookie";
import { Alert } from "@mui/material";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import ReportContext from "../../context/500/ReportContext";
import ReportDetail from "./ReportDetail";
import AddIcon from '@mui/icons-material/Add';
import CourseOfferingCalendar from "./CourseOfferingCalendar";
import OutOfBatch from "./OutOfBatch";
import UpdateOffBatch from "./UpdateOffBatch"


function DivisioComponent() {
  
  let {error ,setError,val,setVal,success}=useContext(CourseAssignmentContext)
  let {showDetailsof,setshowDetailsof}=useContext(ReportContext)

  const auth=GetCookie('auth')
    const [user, setUser] = useState(auth?JSON.parse(auth):null);



  



let navigate=useNavigate()
const [openreport, setOpenreport] =useState(false);

  

  const handleOpen = () => {
    setOpenreport(!openreport);
  };



    function handleChange(event,newValue)
    {
      if(newValue==="ca")
      {
        setshowDetailsof("own")
      }
      else if(newValue==="rc")
      {
        setshowDetailsof("req")
      }
      else
      {
        setshowDetailsof("other")
      }
      
      setVal(newValue)
     
    }
    


    useEffect(()=>{
      if(val==="ca")
      {
        navigate("/courseAssignment/owncourseassignment")
      }
      else if(val==="rc")
      {
        navigate("/courseAssignment/requestcourses")
      }
      else if(val==="ra")
      {
        navigate("/courseAssignment/requestassignment")
      }
      else if(val==="co")
      {
        navigate("/courseAssignment/courseOfferingCalendar")
      }
      else if(val==="ob")
      {
        navigate("/courseAssignment/outofbatch")
      }

    },[val])

    

   

  return (

<React.Fragment>

  <div style={{position:"absolute",top:"155px",right:"30px"}}>
    {error!=="" &&(<Alert severity="error" sx={{ width: '100%'}}>
    {error}
    </Alert>)}
    {success!=="" &&(<Alert severity="success" sx={{ width: '100%' }}>
    {success}
    </Alert>)}

  </div>

<Box sx={{ width: '100%' ,marginTop:"15px",marginBottom:"10px",display:"flex",justifyContent:"space-between"}}>
    <Tabs
      value={val}
      onChange={handleChange}
      textColor="secondary"
      indicatorColor="secondary"
      aria-label="secondary tabs example"
      style={{fontWeight:"bold"}}
    >
    {(user?.roles?.includes(501) && (val!=="co" && val!=="ob")) &&(<Tab value="ca" label="Course Assignment"  style={{fontSize:"14px"}} />)}
    {(user?.roles?.includes(502) && (val!=="co" && val!=="ob"))  &&(<Tab value="rc" label="Request Courses"  style={{fontSize:"14px"}}/>)}
    {(user?.roles?.includes(503) && (val!=="co" && val!=="ob"))  &&( <Tab value="ra" label="Request Assignment"  style={{fontSize:"14px"}}/>)}
    </Tabs>

    <div style={{
      position:"relative"
    }}>
    
    {(val!=="co" && val!=="ob")  &&(<Button variant="contained" style={{margin:"10px 10px"}}  onClick={()=>{setVal("ob")}}>
        <AddIcon style={{marginRight:"5px"}}/>
        Add Out of Batch
      </Button>)}
      {(val!=="co" && val!=="ob")  &&(<Button variant="contained" style={{margin:"10px 10px"}} onClick={()=>{setVal("co")}}>
      Offering Calendar
      </Button>)}

      {(val!=="co" && val!=="ob")  &&(<Button variant="contained" style={{margin:"10px 10px"}} onClick={handleOpen}>
        Open Report
      </Button>)}
      {openreport==true &&(<ReportDetail />)}
    </div>


    



</Box>
      
  <Routes>
 
 <Route element={<RequireAuth allowedRoles={[501]} />}>
 <Route exact path="/owncourseassignment" element={<OwnCourseAssignmentComponent />} />
  </Route>
 
  <Route element={<RequireAuth allowedRoles={[502]} />}>

<Route exact path="/requestcourses" element={  <RequestedCoursesComponent/>} />
</Route>

<Route element={<RequireAuth allowedRoles={[503]} />}>

<Route exact path="/requestassignment" element={<AssignmentForOtherDept />} />
  </Route>

  <Route element={<RequireAuth allowedRoles={[501]} />}>

<Route exact path="/courseOfferingCalendar" element={<CourseOfferingCalendar />} />
  </Route>

  <Route element={<RequireAuth allowedRoles={[501]} />}>

<Route exact path="/outofbatch" element={<OutOfBatch />} />
  </Route>
  <Route element={<RequireAuth allowedRoles={[501]} />}>

<Route exact path="/updateOffBatch" element={<UpdateOffBatch />} />
  </Route>


 
  </Routes>






  </React.Fragment>);
}

export default DivisioComponent;
